module.exports = __webpack_public_path__ + "static/media/phillip-12.cbbfaa33.svg";